export abstract class ExpiryTimeStorage {
  static set<T>(key: string, value: T, ttl: number, storage = localStorage): void {
    const now = new Date();

    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    };
    storage.setItem(key, JSON.stringify(item));
  }

  static get<T>(key: string, storage = localStorage): T | null {
    const itemStr = storage.getItem(key);

    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
      storage.removeItem(key);
      return null;
    }
    return item.value;
  }

  static remove(key: string, storage = localStorage): void {
    storage.removeItem(key);
  }
}
